import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  ListItem,
  Typography,
} from '@mui/material';
import { IMedication } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { format } from 'date-fns';
import { useState } from 'react';
import { WarningWithExpiredDate } from 'Components';

interface IExpiredMedicationProps {
  expiredMedication: IMedication;
}

export const ExpiredMedicationItem = ({
  expiredMedication,
}: IExpiredMedicationProps) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <ListItem sx={{ p: 0, mb: 2 }}>
      <Accordion
        sx={{
          width: '100%',
          boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
          borderRadius: '16px !important',
        }}
      >
        <AccordionSummary
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            p: '24px',
            boxShadow: isExpanded
              ? '0px 4px 28px rgba(45, 112, 217, 0.15)'
              : '',
            borderRadius: isExpanded ? '16px 16px 0 0' : '16px',
          }}
        >
          <Grid container>
            <Typography fontWeight={700}>
              {expiredMedication.medicatioN_NAME}
            </Typography>
          </Grid>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            p: '24px',
          }}
        >
          <Grid container rowSpacing={2}>
            <Grid item>
              <Typography fontWeight={700}>
                {dictionary.nameOfTheMedication}
              </Typography>
              <Typography>{expiredMedication.medicatioN_NAME}</Typography>
            </Grid>
            <Grid item>
              <Typography fontWeight={700}>
                {dictionary.currentPrescriptionValidity}
              </Typography>
              <Typography>
                {format(
                  new Date(expiredMedication.nextrefreshdate),
                  'dd/MM/yyyy'
                )}
              </Typography>
            </Grid>
            <WarningWithExpiredDate
              date={expiredMedication.nextrefreshdate.toString()}
            />
          </Grid>
        </AccordionDetails>
      </Accordion>
    </ListItem>
  );
};
